<template>
  <Layout>
    <div class="section content is-size-7 has-text-white">
      <h1 class="is-size-5 has-text-primary">{{ $t('Imprint') }}</h1>
      <span class="is-size-7">
        <p>
          Ota rohkeasti yhteyttä, jos sinulla on kysyttävää. <br>
          Tukilinjan numero: <a class="has-text-primary" href="tel:00358942451583">+358 942451583</a> <br>
          Palvelulinjan posti: <a class="has-text-primary" href="mailto:keepyoufit.fi@silverlines.info">keepyoufit.fi@silverlines.info</a>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/FI/Contact.vue